import { Skeleton } from '@/components/ui/skeleton'

import * as S from './market-shop-product.styled'

export const MarketShopProductSkeleton = () => (
  <S.PageCard>
    <S.FormLayout>
      <S.FieldsColumn>
        {/* Item name + Category */}
        <S.FieldRow>
          <S.FieldGroup>
            <Skeleton variant="text" height="2rem" width="28%" />
            <Skeleton variant="text" height="4rem" />
            <Skeleton variant="text" height="1.2rem" width="68%" />
          </S.FieldGroup>
          <S.FieldGroup>
            <Skeleton variant="text" height="2rem" width="38%" />
            <Skeleton variant="text" height="4rem" />
            <Skeleton variant="text" height="1.2rem" width="80%" />
          </S.FieldGroup>
        </S.FieldRow>

        {/* Description */}
        <S.FieldGroup>
          <Skeleton variant="text" height="2rem" width="52%" />
          <Skeleton variant="text" height="12.6rem" />
          <Skeleton variant="text" height="1.2rem" width="62%" />
        </S.FieldGroup>

        {/* Tags */}
        <S.FieldGroup>
          <Skeleton variant="text" height="2rem" width="22%" />
          <Skeleton variant="text" height="4rem" />
          <Skeleton variant="text" height="1.2rem" width="90%" />
        </S.FieldGroup>

        {/* SKU + Price */}
        <S.FieldRow>
          <S.FieldGroup>
            <Skeleton variant="text" height="2rem" width="14%" />
            <Skeleton variant="text" height="4rem" />
          </S.FieldGroup>
          <S.FieldGroup>
            <Skeleton variant="text" height="2rem" width="34%" />
            <Skeleton variant="text" height="4rem" />
          </S.FieldGroup>
        </S.FieldRow>

        {/* In stock + Tax */}
        <S.FieldRow>
          <S.InStockContainer>
            <S.FieldGroup>
              <Skeleton variant="text" height="2rem" width="28%" />
              <Skeleton variant="text" height="4rem" />
            </S.FieldGroup>
            <S.SkeletonSwitchRow>
              <Skeleton height="2rem" width="3.6rem" style={{ borderRadius: '99rem' }} />
              <Skeleton variant="text" height="1.4rem" width="5.6rem" />
            </S.SkeletonSwitchRow>
          </S.InStockContainer>
          <S.FieldGroup>
            <Skeleton variant="text" height="2rem" width="18%" />
            <Skeleton variant="text" height="4rem" />
            <Skeleton variant="text" height="1.2rem" width="80%" />
          </S.FieldGroup>
        </S.FieldRow>
      </S.FieldsColumn>

      {/* Image column */}
      <S.ImageColumn>
        <Skeleton variant="text" height="2.4rem" width="30%" />
        <S.ImageUploadSection>
          <Skeleton height="16rem" style={{ borderRadius: '1.2rem' }} />
          <S.SkeletonTextLines>
            <Skeleton variant="text" height="1.4rem" width="85%" />
            <Skeleton variant="text" height="1.4rem" width="50%" />
          </S.SkeletonTextLines>
        </S.ImageUploadSection>
      </S.ImageColumn>
    </S.FormLayout>
  </S.PageCard>
)
